
import {
   AUTH_DISCONNECTED, SHOW_LOADED, SHOW_LOADING, SHOW_CLEARED, SHOWS_LOADING, SHOWS_LOADED,
   SHOW_NOT_FOUND
} from '../mutation-types';

import {
   SHOW_LOAD_METADATA, SHOW_CLEAR_METADATA, SHOWS_LOAD, CART_LOAD, CLEAR_SEARCH_COUNTER, SHOW_EXIT
} from '../actions';
import each from 'lodash/each';
import get from 'lodash/get';

import Crud, { SHOWS } from '../../api/crud';

const api = (function _getAPI() {
   // if (process.env.NODE_ENV !== 'production') {
   //    const Mock = require('../../mocks/shows').default;
   //    return new Mock();
   // }
   return new Crud(SHOWS);
})();

const DEFAULT_STATE = {
   currentId: 0,
   current: null,
   list: [],
   loading: false,

   notFoundReason: null
};

const getters = {
   getCurrentShow: state => state.current,
   getCurrentShowId: state => state.currentId,
   getCurrentShowName: state => get(state, 'current.name', ''),
   isShowLoading: state => state.loading,
   getAllShows: state => state.list,
   getCurrentShowPict: state => state.current ? state.current.bannerUrl : null,
   getLeftPixelOfPict: state => state.current ? state.current.bgImgLeftUrl : null,
   getRightPixelOfPict: state => state.current ? state.current.bgImgRightUrl : null
};

const actions = {
   async [SHOW_LOAD_METADATA]({ commit, dispatch, state }, id) {
      commit(SHOW_LOADING, id);
      let show = state.currentId === id ? state.current : null; //find(state.list, { id } )
      Crud.setEpisodeId(id);
      setTimeout(() => dispatch(CART_LOAD));
      if ( show ) {
         commit(SHOW_LOADED, show);
      } else {
         dispatch(CLEAR_SEARCH_COUNTER);
         try {
            show = await api.get(id);
            commit(SHOW_LOADED, show);
         } catch(e) {
            commit(SHOW_NOT_FOUND, e.reason);
         }
      }
   },
   async [SHOWS_LOAD]({ commit, state }) {
      if (state.list.length) {
         return;
      }
      commit(SHOWS_LOADING);
      const { items } = await api.load();
      commit(SHOWS_LOADED, items);
   },
   [SHOW_CLEAR_METADATA]({ commit }) {
      commit(SHOW_CLEARED);
   },
   [SHOW_EXIT]({ commit, rootGetters }) {
      document.title = rootGetters.l10n['header.title'];
      commit(SHOW_CLEARED);
      commit(SHOW_NOT_FOUND, null);
   }
};

const mutations = {
   [SHOW_CLEARED](state) {
      state.current = null;
      state.currentId = null;
   },
   [SHOW_LOADING](state, showId) {
      state.currentId = showId;
      state.loading = true;
   },
   [SHOW_LOADED](state, show) {
      state.current = show;
      document.title = document.title.split('-')[0] + ' - ' + show.name;
      state.loading = false;
   },
   [SHOWS_LOADING](state) {
      state.loading = true;
   },
   [SHOWS_LOADED](state, list) {
      state.list = list;
      state.loading = false;
   },
   [SHOW_NOT_FOUND](state, reason) {
      state.notFoundReason = reason;
   },

   [AUTH_DISCONNECTED](state) {
      each(DEFAULT_STATE, ( val, key ) => {
         state[key] = val;
      });
   }
};

export default {
   state: { ...DEFAULT_STATE },
   getters,
   actions,
   mutations
};
